export default __webpack_public_path__ + "static/media/icon-minus-button-orange.2365b469.svg";